module.exports = __webpack_public_path__ + "media/images/emblems/Zermatt_Wappen-f77120915a029de05b97a01f936a6630.svg";